import styled from 'styled-components';
import { ifNotProp } from 'styled-tools';
import media from 'themes/media';

export default styled.div`
  padding: ${ifNotProp('withoutPadding', '15px 16px', '0')};
  width: 100%;

  ${media.greaterThan('tablet')`
    padding:  ${ifNotProp('withoutPadding', '15px 20px', '0')};
  `}

  ${media.greaterThan('desktop')`
    padding:  ${ifNotProp('withoutPadding', '15px 26px', '0')};
  `}

  ${media.greaterThan('large')`
    padding:  ${ifNotProp('withoutPadding', '15px 30px', '0')};
  `}
`;
